import styled from 'styled-components';
import { SearchInputResult } from '../../../search/components/search-bar/SearchLocationResults';
import SearchResult from './SearchResult';
import useOnClickOutside from '../../../../hooks/ClickOutside';
import { useRef } from 'react';
import { Destination } from '../../types';
import { useTranslation } from 'next-i18next';
import LinearProgress from '../../../../new-components/LinearProgress';

interface ResultsDropDownProps {
  isLoading: boolean;
  isError: boolean;
  searchResults: SearchInputResult[];
  handleClick: (selection: SearchInputResult) => void;
  closeDropdown: () => void;
  destination?: Destination;
}

const ResultsDropdown = ({
  isLoading,
  isError,
  searchResults,
  handleClick,
  closeDropdown,
  destination
}: ResultsDropDownProps) => {
  const { t } = useTranslation('search');

  const dropdownRef = useRef(null);

  useOnClickOutside(dropdownRef, dropdownRef, closeDropdown);

  return (
    <Container ref={dropdownRef}>
      {isLoading ? (
        <div className="loader">
          <LinearProgress />
        </div>
      ) : (
        <LinearProgressPlaceholder />
      )}

      {isError || searchResults?.length === 0 ? (
        <span className="no-results">{t('no_results_found')}</span>
      ) : (
        searchResults?.map((result: SearchInputResult) => (
          <SearchResult
            key={result.id}
            result={result}
            handleClick={handleClick}
            destination={destination}
          />
        ))
      )}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  max-height: 250px;
  position: absolute;
  top: 50px;
  left: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  border: 1px solid #f0f1f3;
  //border-radius: 8px;
  border-radius: 8px;
  box-shadow:
    0px 0px 4px 0px rgba(0, 0, 0, 0.04),
    0px 4px 8px 0px rgba(0, 0, 0, 0.06);
  z-index: 999;
  background-color: white;
  overflow-y: auto;

  .no-results {
    padding: 16px;
    font-size: 14px;
    font-family: materialRegular;
  }

  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;

  .loader {
    position: relative;
    width: 100%;
    height: 10px;
    z-index: 99;
  }
`;

const LinearProgressPlaceholder = styled.div`
  margin-bottom: 10px;
  width: 100%;
  visibility: hidden;
`;

export default ResultsDropdown;
